/* RAHID prefetch-on-hover: navegacion casi instantanea entre productos y colecciones */
(function () {
  try {
    var conn = navigator.connection;
    if (conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || ''))) return;
    var testLink = document.createElement('link');
    if (!testLink.relList || !testLink.relList.supports || !testLink.relList.supports('prefetch')) return;

    var done = {};
    var hoverTimer = null;

    function shouldSkip(a) {
      if (!a || !a.href) return true;
      if (a.origin !== location.origin) return true;          // solo mismo dominio
      if (a.hasAttribute('download') || a.target === '_blank') return true;
      var h = a.href;
      if (h === location.href) return true;
      if (/[?#]/.test(h)) return true;                        // evita filtros/variantes
      if (/\/(cart|checkout|account|challenge)(\/|$|\?)/.test(h)) return true;
      return false;
    }

    function prefetch(href) {
      if (done[href]) return;
      done[href] = 1;
      var l = document.createElement('link');
      l.rel = 'prefetch';
      l.href = href;
      l.as = 'document';
      document.head.appendChild(l);
    }

    document.addEventListener('mouseover', function (e) {
      var a = e.target.closest ? e.target.closest('a') : null;
      if (shouldSkip(a)) return;
      var href = a.href;
      hoverTimer = setTimeout(function () { prefetch(href); }, 65);
    }, { capture: true, passive: true });

    document.addEventListener('mouseout', function () {
      if (hoverTimer) { clearTimeout(hoverTimer); hoverTimer = null; }
    }, { capture: true, passive: true });

    document.addEventListener('touchstart', function (e) {
      var a = e.target.closest ? e.target.closest('a') : null;
      if (shouldSkip(a)) return;
      prefetch(a.href);
    }, { capture: true, passive: true });
  } catch (err) {}
})();

/* RAHID i18n sweep: traduce textos sueltos en ingles que quedan hardcodeados en el tema/JS */
(function () {
  var map = {
    'You may also like': 'También te puede gustar',
    'ADD TO CART': 'AÑADIR AL CARRITO',
    'Add to cart': 'Añadir al carrito',
    'ADD TO WISHLIST': 'AGREGAR A FAVORITOS',
    'ADD TO COMPARE': 'AGREGAR A COMPARAR',
    'Previous': 'Anterior',
    'Next': 'Siguiente'
  };
  function fixEl(el) {
    if (el.children.length === 0) {
      var k = (el.textContent || '').trim();
      if (map[k]) el.textContent = map[k];
    }
    if (el.getAttribute) {
      var al = el.getAttribute('aria-label');
      if (al && map[al.trim()]) el.setAttribute('aria-label', map[al.trim()]);
    }
  }
  function sweep() {
    document.querySelectorAll(
      'h2.tt-title-small, .tt-block-title h2, .slick-prev, .slick-next, a.stickyaddtocart, .btn.stickyaddtocart'
    ).forEach(fixEl);
  }
  function run() { try { sweep(); } catch (e) {} }
  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
  try {
    var t = null;
    new MutationObserver(function () {
      if (t) return;
      t = setTimeout(function () { t = null; run(); }, 150);
    }).observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();

/* RAHID: emblema del hero clicable -> Inicio */
(function () {
  function linkEmblem() {
    document.querySelectorAll('.rahid-hero__logo').forEach(function (el) {
      if (el.dataset.rhHome) return;
      el.dataset.rhHome = '1';
      el.style.cursor = 'pointer';
      el.setAttribute('role', 'link');
      el.setAttribute('tabindex', '0');
      el.setAttribute('aria-label', 'Inicio');
      var go = function () { window.location.href = '/'; };
      el.addEventListener('click', go);
      el.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); } });
    });
  }
  if (document.readyState !== 'loading') linkEmblem();
  else document.addEventListener('DOMContentLoaded', linkEmblem);
})();
